// @flow
import React, { Component } from 'react'
import { Button } from 'react-bootstrap'
import styles from './opportunityTagsReviewed.less'
import * as actions from '../actions'
import { connect } from 'react-redux'
import { getAuth, getOpportunity, getOpportunityById } from '../selectors'
import Gravatar from 'react-gravatar'
import type { OpportunityType } from '../types/OpportunityType'
import Loading from './Loading'
import Date from '../components/Date'

class OpportunityTagsReviewed extends Component {
  props: {
    isFetching: boolean,
    auth: {
      email: string,
    },
    fetchOpportunity: Function,
    item: OpportunityType,
    params: {
      id: string,
    },
    postOpportunityTagsReviewed: Function,
    isPostingOpportunityTagsReviewed: boolean,
  }

  render() {
    const {
      item,
      isFetching,
      auth,
      postOpportunityTagsReviewed,
      isPostingOpportunityTagsReviewed,
    } = this.props

    if (!item || isFetching || isPostingOpportunityTagsReviewed) {
      return <Loading className="text-center" />
    }

    return (
      <div className={styles.reviewedByLabel}>
        {item.tagsReviewedOnUtc
          ? <div style={{ marginBottom: 5 }}>
              {' '}
              <Gravatar
                email={item.tagsReviewedByEmail}
                size={22}
                className={styles.avatar}
                style={{ marginRight: '5px' }}
                title={item.tagsReviewedByEmail}
              />
              reviewed on
              {' '}
              <Date
                date={item.tagsReviewedOnUtc}
                format="MMMM DD, YYYY @ hh:mm"
              />
            </div>
          : null}
        <Button
          className={styles.reviewButton}
          bsSize="sm"
          onClick={() => {
            postOpportunityTagsReviewed({
              opportunityId: item.id,
              userEmail: auth.email,
            })
          }}
        >
          Mark as reviewed by
          <Gravatar
            email={auth.email}
            title={auth.email}
            size={22}
            className={styles.avatar}
          />
        </Button>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  isFetching: getOpportunity(state).isFetching,
  item: getOpportunityById({ state, id: Number(ownProps.params.id) }),
  auth: getAuth(state),
})

export default connect(mapStateToProps, actions)(OpportunityTagsReviewed)



// WEBPACK FOOTER //
// ./src/components/OpportunityTagsReviewed.js